<template>
  <div>
    <modal
      id="p-list-representation-record-modal"
      class="p-list-representation-record-modal"
      size="800px"
      :show.sync="show"
      :footer="false"
    >
        <Loader class="w-100" :loading="loading">
            <div class="p-list-representation-record-modal-content w-100 row">
                  <div class="form-group d-flex flex-wrap w-100 justify-content-center mb-0 col-10 mr-auto ml-auto">
                      <form v-on:submit.prevent="submit" class="row w-100">
                            <div :class="{ 'p-list-representation-error': $v.formData.value_update_start_time.$error }" class="d-flex w-100 align-items-center flex-column mb-3" >
                              <label class="ml-3 p-list-representation-label-text mb-2">
                                ساعت شروع
                              </label>
                              <input v-model="formData.value_update_start_time" type="text" placeholder="" class="form-control text-right w-100">
                            </div>
                            <div :class="{ 'p-list-representation-error': $v.formData.value_update_end_time.$error }" class="d-flex w-100 align-items-center flex-column mb-3" >
                              <label  for="namyFamily " class="ml-3 p-list-representation-label-text mb-2">
                                ساعت پایان
                              </label>
                              <input v-model="formData.value_update_end_time" type="text" placeholder="" class="form-control text-right w-100">
                            </div>
                            <button type="submit" class="btn btn-primary btn-blue btn-sm col-4 mr-auto ml-auto">ثبت</button>
                      </form>
                  </div>
            </div>
        </Loader>
    </modal>
  </div>
</template>

<script>
import { required, minLength,between,numeric } from 'vuelidate/lib/validators'

export default {
    name: 'modalEditSalon',
    props: {
      active              : { type: [Boolean, Number], default: false },
      formDataOriginal    : {type:[Array,Object],default:{}},
      clearForm           :  {type:Number,default:0},
      currentDataItemSans : {type:[Array,Object],default:{}},
      loading             : {type:Boolean,default:false},

    },

    data() {
      return {
        formData : {

        }
      }
    },

    validations: {
      formData : {
          value_update_end_time: {
            required,
          },
          value_update_start_time: {
            required,
          },


      }
    },

    computed: {
      show: {
        set(val) {
          this.$emit('update:active', !!val)
        },
        get() {
          return !!this.active
        }
      },
    },

    watch: {
      currentDataItemSans(data){
        data.hall_id                 = this.formDataOriginal.hall_id;
        data.value_update_start_time = data.start_time;
        data.value_update_end_time   = data.end_time;
        this.formData                = data;
      },
    },

    mounted () {
    },


    methods: {
      submit(){
        this.$v.$touch()

        if (this.$v.$invalid) {
          this.$message.error('لطفا اطلاعات خود را بررسی کنید')
        }
        else {
          this.$emit('submitEdit',this.formData);
        }
      }

    },

}
</script>
